"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = _interopRequireWildcard(require("react"));
var _SidebarMenu = require("./SidebarMenu.style");
var _Icon = _interopRequireDefault(require("../../Icon"));
var _useOnclickoutside = _interopRequireDefault(require("use-onclickoutside"));
var _SidebarExpandedMenu = _interopRequireDefault(require("./SidebarExpandedMenu"));
var _SidebarCollapsedMenu = _interopRequireDefault(require("./SidebarCollapsedMenu"));
var _helpers = require("../../../utils/helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable @typescript-eslint/no-unused-expressions */

const SidebarList = _ref => {
  let {
    activeNav,
    items,
    isExpanded,
    showLabelOnCollapse,
    theme,
    minWidth,
    onNavClick
  } = _ref;
  const subMenuRef = _react["default"].useRef(null);
  const [selectedMenuItems, setSelectedMenuItems] = (0, _react.useState)([]);
  const onSubMenuOutsiteClick = () => {
    onCollapseSubMenu();
  };
  (0, _useOnclickoutside["default"])(subMenuRef, onSubMenuOutsiteClick);
  const onMenuItemClick = itemId => {
    selectedMenuItems.includes(itemId) ? setSelectedMenuItems(prevActiveSubMenus => prevActiveSubMenus.filter(item => item !== itemId)) : setSelectedMenuItems(prevActiveSubMenus => [].concat((0, _toConsumableArray2["default"])(prevActiveSubMenus), [itemId]));
  };
  const onCollapseSubMenu = menuActiceItems => {
    (menuActiceItems === null || menuActiceItems === void 0 ? void 0 : menuActiceItems.length) ? setSelectedMenuItems(menuActiceItems) : setSelectedMenuItems([]);
  };
  return (0, _jsxRuntime.jsx)(_SidebarMenu.Components.MenuWrapper, (0, _extends2["default"])({
    isExpanded: isExpanded
  }, {
    children: (0, _jsxRuntime.jsx)(_SidebarMenu.Components.MenuList, {
      children: items.map((item, idx) => {
        const {
          id,
          icon,
          title,
          subMenu
        } = item;
        const isIconCustomImage = typeof icon === 'string' && _helpers.customImagePattern.test(icon);
        const isActiveNav = activeNav === id;
        const isSubMenuActive = selectedMenuItems.includes(id || '');
        return (0, _jsxRuntime.jsxs)(_SidebarMenu.Components.MenuListItem, (0, _extends2["default"])({
          className: "sidebar-menu",
          themeMode: theme,
          isSubMenuActive: isSubMenuActive,
          onClick: e => {
            var _a;
            e.stopPropagation();
            e.preventDefault();
            if ((_a = item === null || item === void 0 ? void 0 : item.subMenu) === null || _a === void 0 ? void 0 : _a.length) {
              onMenuItemClick(id || '');
            } else {
              onNavClick && onNavClick(item.path, item, e);
              onCollapseSubMenu();
            }
          }
        }, {
          children: [(0, _jsxRuntime.jsxs)(_SidebarMenu.Components.MenuItemContent, (0, _extends2["default"])({
            isExpanded: isExpanded,
            isActiveNav: isActiveNav,
            themeMode: theme
          }, {
            children: [(0, _jsxRuntime.jsxs)(_SidebarMenu.Components.ContentWrapper, (0, _extends2["default"])({
              isExpanded: isExpanded,
              themeMode: theme
            }, {
              children: [typeof icon !== 'string' ? icon : isIconCustomImage ? (0, _jsxRuntime.jsx)(_SidebarMenu.Components.CustomImageIcon, {
                src: icon,
                alt: 'Loading'
              }) : (0, _jsxRuntime.jsx)(_Icon["default"], {
                name: icon,
                size: "20"
              }), (isExpanded || showLabelOnCollapse) && (0, _jsxRuntime.jsx)(_SidebarMenu.Components.ItemTitle, (0, _extends2["default"])({
                variant: isExpanded ? 'body1' : 'body2',
                isExpanded: isExpanded,
                themeMode: theme
              }, {
                children: title || 'N/A'
              }))]
            })), isExpanded && (subMenu === null || subMenu === void 0 ? void 0 : subMenu.length) && (0, _jsxRuntime.jsx)(_SidebarMenu.Components.DropdownIcon, {
              name: isSubMenuActive ? 'chevron-down' : 'chevron-right',
              themeMode: theme
            })]
          })), isSubMenuActive && (subMenu === null || subMenu === void 0 ? void 0 : subMenu.length) ? isExpanded ? (0, _jsxRuntime.jsx)(_SidebarExpandedMenu["default"], {
            activeNav: activeNav,
            item: item,
            selectedMenuItems: selectedMenuItems,
            theme: theme,
            onNavClick: onNavClick,
            onMenuItemClick: onMenuItemClick,
            onCollapseSubMenu: onCollapseSubMenu
          }) : (0, _jsxRuntime.jsx)(_SidebarCollapsedMenu["default"], {
            activeNav: activeNav,
            item: item,
            selectedMenuItems: selectedMenuItems,
            subMenuRef: subMenuRef,
            minWidth: minWidth,
            theme: theme,
            onNavClick: onNavClick,
            onMenuItemClick: onMenuItemClick,
            onCollapseSubMenu: onCollapseSubMenu
          }) : (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {})]
        }), idx);
      })
    })
  }));
};
var _default = exports["default"] = SidebarList;